/**
 * @author Daniel Laurindo daniellaurindo@sagaranatech.com.br
 * DATE 06/09/2013
 *  Time: 16:00
 */



Greenmile.ClusterEquipmentStatus = {

    count: 0,

    child: undefined,

    status: [],

    read: function (cluster) {

        var view = Greenmile.ClusterEquipmentStatus;
        view.status = {};

        var clusterStatus = {
            noComunication: 0,
            turnedOf: 0,
            moving: 0,
            stopped: 0
        };

        if (typeof cluster._childClusters !== "undefined" && cluster._childClusters.length > 0) {

            var leaflet_id = cluster._leaflet_id;

            clusterStatus = view.build_parent(cluster._childClusters, clusterStatus);

            view.status[leaflet_id] = clusterStatus;

        }

        if (typeof cluster._markers !== 'undefined') {

            var leafletId = cluster._leaflet_id;
            clusterStatus = view.read_markers(cluster._markers, clusterStatus);
            view.status[leafletId] = clusterStatus;

        }

        return view.status;

    },

    build_parent: function (_childClusters, clusterStatus) {

        var view = Greenmile.ClusterEquipmentStatus;
        var size = _childClusters.length;

        var build_child = function () {

            for (var index = 0; index < size; index++) {

                if (typeof _childClusters[index]._childClusters !== "undefined") {

                    view.build_parent(_childClusters[index]._childClusters, clusterStatus);

                    view.read_markers(_childClusters[index]._markers, clusterStatus);

                }

            }

        };

        if (size > 0) {

            build_child();

        }

        return clusterStatus;

    },

    read_markers: function (markers, clusterStatus) {

        for (var x = 0, len = markers.length; x < len; x++) {

            switch (markers[x].options.icon.options.status) {
                case 'truckWithoutCommunication':
                    clusterStatus.noComunication++;
                    break;
                case 'truckOff':
                    clusterStatus.turnedOf++;
                    break;
                case 'truckOnAndMoving':
                    clusterStatus.moving++;
                    break;
                case 'truckOnAndStopped':
                    clusterStatus.stopped++;
                    break;
                default:
                    clusterStatus.noComunication++;
                    break;
            }

        }

        return clusterStatus;

    }

};

Greenmile.GeneratePieChart = {

    createPieBackground: function(pieSize, baseColor) {
        var pieBackground = document.createElement("div");
        pieBackground.style.width = pieSize;
        pieBackground.style.height = pieSize;
        pieBackground.style.position = "relative";
        pieBackground.style.borderRadius = pieSize;
        pieBackground.style.backgroundColor = baseColor;

        return pieBackground;
    },

    createSlice: function(pieSize, sizeNum, absoluteValues) {
        var newSlice = document.createElement("div");

        newSlice.style.position = "absolute";
        newSlice.style.top = "0px";
        newSlice.style.left = "0px";
        newSlice.style.width = pieSize;
        newSlice.style.height = pieSize;
        newSlice.style.webkitBorderRadius = pieSize;
        newSlice.style.mozBorderRadius = pieSize;
        newSlice.style.borderRadius = pieSize;
        newSlice.style.clip = "rect(0px," + pieSize + "," + pieSize + "," + ((sizeNum) / 2) + "px)";
        newSlice.title = this.titleGenerator(absoluteValues);

        return newSlice;
    },

    createSlicePie: function(index, colors, pieSize, sizeNum, absoluteValues) {
        var pie = document.createElement("div");

        pie.style.backgroundColor = colors[index];
        pie.style.position = "absolute";
        pie.style.top = "0px";
        pie.style.left = "0px";
        pie.style.width = pieSize;
        pie.style.height = pieSize;
        pie.style.webkitBorderRadius = pieSize;
        pie.style.mozBorderRadius = pieSize;
        pie.style.borderRadius = pieSize;
        pie.style.clip = "rect(0px, " + ((sizeNum) / 2) + "px, " + pieSize + ", 0px)";
        pie.title = this.titleGenerator(absoluteValues);

        return pie;
    },

    createPie: function (values) {

        var sizeNum = 36;
        var pieSize = '36px';
        var baseColor = 'transparent';

        //Loop through all slices
        var colors = ['#EE3C25', '#4AbA71', '#Fbb040', '#24242A'];

        // colocar pra receber como parâmetro
        var percentages = [values.percents.noCommunication, values.percents.moving, values.percents.stopped, values.percents.turnedOf];
        var absoluteValues = [values.absolutes.noCommunication, values.absolutes.moving, values.absolutes.stopped, values.absolutes.turnedOf];

        // usar esses valores pra testar
        var NumberOfSlices = 4;

        //Pie Container
        var pieContainer = document.createElement("div");
        pieContainer.style.display = "inline-block";

        //Pie Background
        var pieBackground = this.createPieBackground(pieSize, baseColor);

        //Append Background to Container
        pieContainer.appendChild(pieBackground);

        //Loop through Slices
        var beforeDegree = 0;
        var degree = 0;
        var newSlice;
        var pie;

        Monet.Maps.LegendCluster = [];

        for (var i = 0; i < NumberOfSlices; i++) {

            //New Slice
            newSlice = this.createSlice(pieSize, sizeNum, absoluteValues);

            Monet.Maps.LegendCluster.push({ title: newSlice.title });

            if (percentages[i] === 0) {
                newSlice.style.display = 'none';
            }

            //New Slice Pie
            pie = this.createSlicePie(i, colors, pieSize, sizeNum, absoluteValues);

            Monet.Maps.LegendCluster.push({ title: pie.title });

            //Get Percentage
            var piePercentage = percentages[i];

            //Check if Percentage > 50
            if (piePercentage <= 50) {

                degree = parseFloat((180 * piePercentage) / 50);

                pie.style.webkitTransform = "rotate(" + degree + "deg)";
                pie.style.mozTransform = "rotate(" + degree + "deg)";
                pie.style.transform = "rotate(" + degree + "deg)";

                newSlice.appendChild(pie);

                //If it's not first slice, then ...
                if (i !== 0) {
                    newSlice.style.webkitTransform = "rotate(" + beforeDegree + "deg)";
                    newSlice.style.mozTransform = "rotate(" + beforeDegree + "deg)";
                    newSlice.style.transform = "rotate(" + beforeDegree + "deg)";
                }

                pieBackground.appendChild(newSlice);
                beforeDegree += degree;

            }

            else {

                newSlice.style.clip = "rect(0px," + (sizeNum) + "px," + (sizeNum) + "px," + ((sizeNum - 100) / 2) + "px)";
                newSlice.style.webkitTransform = "rotate(" + beforeDegree + "deg)";
                newSlice.style.mozTransform = "rotate(" + beforeDegree + "deg)";
                newSlice.style.transform = "rotate(" + beforeDegree + "deg)";
                newSlice.title = this.titleGenerator(i, percentages[i]);
                Monet.Maps.LegendCluster.push({ title: newSlice.title });

                pie.style.webkitTransform = "rotate(180deg)";
                pie.style.mozTransform = "rotate(180deg)";
                pie.style.transform = "rotate(180deg)";

                newSlice.appendChild(pie);
                pieBackground.appendChild(newSlice);

                newSlice = this.createSlice(pieSize, sizeNum, absoluteValues);

                Monet.Maps.LegendCluster.push({ title: newSlice.title });

                if (i !== 0) {
                    beforeDegree = beforeDegree - 1;
                }

                newSlice.style.webkitTransform = "rotate(" + (180 + beforeDegree) + "deg)";
                newSlice.style.mozTransform = "rotate(" + (180 + beforeDegree) + "deg)";
                newSlice.style.transform = "rotate(" + (180 + beforeDegree) + "deg)";

                if (i !== 0) {
                    beforeDegree = beforeDegree + 1;
                }

                pie = this.createSlicePie(i, colors, pieSize, sizeNum, absoluteValues);

                Monet.Maps.LegendCluster.push({ title: pie.title });

                degree = parseFloat(((piePercentage - 50) * 180) / 50);

                if (i !== 0) {
                    degree = degree + 1;
                }

                pie.style.webkitTransform = "rotate(" + degree + "deg)";
                pie.style.mozTransform = "rotate(" + degree + "deg)";
                pie.style.transform = "rotate(" + degree + "deg)";

                if (i !== 0) {
                    degree = degree - 1;
                }

                newSlice.appendChild(pie);
                pieBackground.appendChild(newSlice);
                beforeDegree += (180 + degree);
            }

        }

        //Circle Background Total
        var pieCircleTotal = document.createElement("div");

        pieCircleTotal.style.width = "24px";
        pieCircleTotal.style.height = "24px";
        pieCircleTotal.style.position = "absolute";
        pieCircleTotal.style.right = "6px";
        pieCircleTotal.style.top = "6px";
        pieCircleTotal.style.borderRadius = "100%";
        pieCircleTotal.style.backgroundColor = "rgb(245, 245, 245)";

        //Append Background to Container
        pieBackground.appendChild(pieCircleTotal);

        //Number Background Total
        var pieNumberTotal = document.createElement("div");
        pieNumberTotal.style.color = "rgb(40, 40, 40)";
        pieNumberTotal.style.fontSize = "10px";
        pieNumberTotal.style.textAlign = "center";
        pieNumberTotal.style.marginTop = "4px";
        pieNumberTotal.innerHTML = values.total;

        //Append Circle Background to Container
        pieCircleTotal.appendChild(pieNumberTotal);

        var titlesLegend = Monet.Maps.LegendCluster,
            titleResult  = null;

        if (titlesLegend.length !== 0) {
            for (var j = 0; j < titlesLegend.length; j++) {
                if (typeof titlesLegend[j].title !== 'undefined') {
                    titleResult = titlesLegend[j].title;
                }
            }
        }

        pieContainer.title = titleResult;

        return pieContainer.outerHTML;

    },

    titleGenerator: function (absolutes) {

        var html = '', i18n = Monet.I18n;

        if (absolutes[0] > 0) {
            html += i18n.getResourcesByKey('RouteMonitor.Cluster.NoCommunication') + ': ' + absolutes[0] + '\n';
        }

        if (absolutes[1]) {
            html += i18n.getResourcesByKey('RouteMonitor.Cluster.Moving') + ': ' + absolutes[1] + '\n';
        }

        if (absolutes[2]) {
            html += i18n.getResourcesByKey('RouteMonitor.Cluster.Stopped') + ': ' + absolutes[2] + '\n';
        }

        if (absolutes[3]) {
            html += i18n.getResourcesByKey('RouteMonitor.Cluster.TurnedOf') + ': ' + absolutes[3];
        }

        return html;

    }
};